export type ColWindow = { start: number; end: number };

/**
 * Resolve a column window against the current item count. Clamps `[start, end)` into
 * `[0, itemCount]` (a stale window left over from a longer range can point past the new end) and
 * derives non-negative left/right spacer widths. leftPad + rendered + rightPad always spans the
 * full row, so scroll width and column alignment match a fully-rendered row regardless of window.
 */
export function dayWindowBounds(itemCount: number, win: ColWindow, colWidth: number) {
    const start = Math.max(0, Math.min(win.start, itemCount));
    const end = Math.max(start, Math.min(win.end, itemCount));
    return { start, end, leftPad: start * colWidth, rightPad: (itemCount - end) * colWidth };
}
